export enum VaccineType {
  ASTRAZENECA = 'AstraZeneca',
  BOOSTER = 'Booster',
  MODERNA = 'Moderna',
  MODERNA_FOR_6_11S = 'Moderna for 6-11s',
  MODERNA_FOR_6M_5Y = 'Moderna for 6mth to 5yrs',
  NOVAVAX = 'Novavax',
  PFIZER = 'Pfizer',
  PFIZER_FOR_5_11S = 'Pfizer for 5-11s',
  MODERNA_BIVALENT = 'Moderna Bivalent',
  PFIZER_BIVALENT = 'Pfizer Bivalent',
  PFIZER_FOR_6M_4Y = 'Pfizer for 6mth to 4yrs',
}
